// src/app/not-found.tsx
"use client";

import Image from "next/image";

export default function NotFound() {
	return (
		<div className="flex flex-col items-center justify-center bg-white text-center px-4 py-12 md:py-16">
			<div className="max-w-xl w-full">
				{/* Space for SVG - add your custom SVG here */}
				<div className="flex justify-center mb-6">
					<Image
						src="/new_icons/general/404-icon.svg"
						alt="404 icon"
						width={225}
						height={225}
					/>
				</div>

				{/* Main heading */}
				<h1 className="text-xl md:text-[24px] text-automint-black mb-3">
					404: This page took a wrong turn.
				</h1>

				{/* Description text */}
				<p className="text-gray-600 text-sm max-w-md mx-auto mb-8">
					We&apos;ve sent out a search party, but honestly, it might be
					soul-searching in a rest stop somewhere.
				</p>

				{/* Go to homepage button */}
				<button
					onClick={() => (window.location.href = "/")}
					className="bg-black text-automint-neon px-14 py-3 rounded-2xl hover:bg-gray-800 transition-colors"
				>
					Go to homepage
				</button>
			</div>
		</div>
	);
}
